import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { Button, Divider, makeStyles, MessageBar, MessageBarActions, MessageBarBody, MessageBarTitle, NavCategory, NavDrawer, NavDrawerBody, Tab, TabList, tokens } from "@fluentui/react-components";
import { AirplaneFilled, BranchFilled, BranchRegular, bundleIcon, CircleMultipleConcentricFilled, CircleMultipleConcentricRegular, InfoFilled, InfoRegular, HeartPulseFilled, HeartPulseRegular } from "@fluentui/react-icons";
import FlightOps_Overview from "./components/FlightOps_Overview";
import FlightOps_Branches from "./components/FlightOps_Branches";
import FlightOps_Rings from "./components/FlightOps_Rings";
import FlightOps_HealthStatus from "./components/FlightOps_HealthStatus";

const useStyles = makeStyles({
    navContentRoot: {
        display: "flex",
        width: "100%",
        height: "100%",
        marginTop: "1rem"
    },
    navContent__tabList: {
        minWidth: "200px",
        height: "100%",
        borderRight: "1px solid " + tokens.colorNeutralStroke1,

        "& .fui-Divider": {
            flexGrow: "0",
            padding: "0.5rem 0"
        }
    },
    navContentPane: {
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        width: "100%",
        overflow: "hidden auto"
    }
});

const InfoIcon = bundleIcon(InfoFilled, InfoRegular);
const BranchesIcon = bundleIcon(BranchFilled, BranchRegular);
const RingsIcon = bundleIcon(CircleMultipleConcentricFilled, CircleMultipleConcentricRegular);
const HealthStatusIcon = bundleIcon(HeartPulseFilled, HeartPulseRegular);

const getPageTitle = ( id: string ) => {
    switch( id ) {
        case "overview": return "Overview";
        case "branches": return "Branches";
        case "rings": return "Rings";
        case "health": return "Health Status";
    }

    return "Unknown Page";
};

export default function FlightOpsPage() {
    const styles = useStyles();
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            let subPage = window.location.hash.substring( 1 );
            if( !subPage.length )
                subPage = "overview";

            updateDocumentTitle( "Flight Operations | " + getPageTitle( subPage ) );
            navData.sidebarSelectedNavValue = "flightops";
            navData.subPageNavValue = subPage;
            setNavData({...navData});
        },
        []
    );

    const changeTab = ( tabValue: string ) => {
        navData.subPageNavValue = tabValue;
        setNavData( { ...navData } );

        updateDocumentTitle( "Flight Operations | " + getPageTitle( tabValue ) );
        window.location.hash = tabValue;
    };

    return (
        <>
            <SubPageTitle icon={<AirplaneFilled />} title="Flight Operations" subTitle={getPageTitle( navData.subPageNavValue as string )} />

            <div className={styles.navContentRoot}>
                <TabList className={styles.navContent__tabList} vertical selectedValue={navData.subPageNavValue} onTabSelect={( _, d ) => changeTab( d.value as string )}>
                    <Tab value="overview" icon={<InfoIcon />}>Overview</Tab>
                    <Divider />
                    <Tab value="branches" icon={<BranchesIcon />}>Branches</Tab>
                    <Tab value="rings" icon={<RingsIcon />}>Rings</Tab>
                    <Tab value="health" icon={<HealthStatusIcon />}>Health Status</Tab>
                </TabList>

                <div className={styles.navContentPane}>
                    {
                        navData.subPageNavValue == "overview" ? <FlightOps_Overview /> :
                        navData.subPageNavValue == "branches" ? <FlightOps_Branches /> :
                        navData.subPageNavValue == "rings" ? <FlightOps_Rings /> :
                        navData.subPageNavValue == "health" ? <FlightOps_HealthStatus /> : null
                    }
                </div>
            </div>
        </>
    );
}